// extracted by mini-css-extract-plugin
export var check = "Table-module--check--5b39b";
export var comparisonTableWrapper = "Table-module--comparisonTableWrapper--3e50d";
export var cross = "Table-module--cross--f972c";
export var defaultTable = "Table-module--defaultTable--adb02";
export var highlight = "Table-module--highlight--dc728";
export var noSection = "Table-module--noSection--a4936";
export var popSection = "Table-module--popSection--f064e";
export var popTable = "Table-module--popTable--383af";
export var title = "Table-module--title--1b0ff";